import { render, staticRenderFns } from "./help.vue?vue&type=template&id=49f9406e&scoped=true&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style1 from "./help.vue?vue&type=style&index=1&id=49f9406e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f9406e",
  null
  
)

export default component.exports